import './UserControls.scss';
import { createAsyncSelectors } from '@lib/selectors';
import { ImpersonateUserButton } from './ImpersonateUserButton';
import { ResendUserInviteButton } from './ResendUserInviteButton';
import { SendPasswordResetButton } from './SendPasswordResetButton';
import { UserLockStateToggleButton } from './UserLockStateToggleButton';
import React, { useEffect } from 'react';
import { useBoolean, useSonarSelector } from '@hooks';
const lockAllUsersSelectors = createAsyncSelectors((state) => state.admin.customers.byId.lockAllUsers.post);
export const UserControls = ({ user, shardName }) => {
    const [lockOverride, setLockOverride] = useBoolean(false);
    const isLocked = (user === null || user === void 0 ? void 0 : user.isLocked) || lockOverride;
    const lockAllUsersIsReceived = useSonarSelector(lockAllUsersSelectors.isReceived);
    useEffect(() => {
        if (lockAllUsersIsReceived) {
            setLockOverride.on();
        }
    }, [lockAllUsersIsReceived, setLockOverride]);
    if (!user || !shardName) {
        return null;
    }
    return (React.createElement("div", { className: 'admin-user-controls' },
        React.createElement(ImpersonateUserButton, { shardName: shardName, userId: user === null || user === void 0 ? void 0 : user.id, userIsLocked: isLocked }),
        React.createElement(UserLockStateToggleButton, { onChange: setLockOverride.off, shardName: shardName, user: user, userIsLocked: isLocked }),
        user.ownedBySonar &&
            React.createElement(SendPasswordResetButton, { shardName: shardName, userId: user === null || user === void 0 ? void 0 : user.id, userIsLocked: isLocked }),
        user.ownedBySonar && !user.isEmailVerified &&
            React.createElement(ResendUserInviteButton, { shardName: shardName, userId: user === null || user === void 0 ? void 0 : user.id, userIsLocked: isLocked })));
};
